import { render } from "./FeaturesSection.vue?vue&type=template&id=a48e6a36&scoped=true"
import script from "./FeaturesSection.vue?vue&type=script&lang=js"
export * from "./FeaturesSection.vue?vue&type=script&lang=js"

import "./FeaturesSection.vue?vue&type=style&index=0&id=a48e6a36&lang=scss&scoped=true"

import exportComponent from "/Users/jackwaghorn/Documents/Projects/VibeLab/Creative Footprint/Creative Footprint Montreal/Montreal microsite/cfp-m-v1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a48e6a36"]])

export default __exports__